// @flow
import React, { Component } from 'react';
import _ from 'lodash';
import './FormInputWithError.scss';

type Props = {
  required: boolean,
  name: string,
  error: Object,
  hasError: Function,
  children: Object,
}

export default class FormInputWithError extends Component {
  props: Props;

  showError = (showError: boolean, errorMessages: Object, name: string) => {
    return showError && !_.isEmpty(errorMessages) && !_.isUndefined(errorMessages[name]);
  };

  listErrorMessages = (errorMessages: Object, name: string) => {
    return _.get(errorMessages, name).join(', ');
  };

  render() {
    const { error, name, hasError } = this.props;
    const isError = typeof hasError === 'function' ? hasError(name) : false;
    const childrenWthProps = React.Children.map(this.props.children,
      (child) => React.cloneElement(child, { error: isError, name, ...child.props })
    );

    return (
      <span className="input-field">
        {childrenWthProps}
        {this.showError(isError, error, name) &&
          <div>
            <span className="validation-tooltip">
              {this.listErrorMessages(error, name)}
            </span>
            <span className="validation-icon" />
          </div>
        }
      </span>
    );
  }
}
